import {AfterViewInit, Component, ElementRef, forwardRef, Input, OnInit, Renderer2} from '@angular/core';
import {SearchCountryField, CountryISO, PhoneNumberFormat} from 'ngx-intl-tel-input';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';


@Component({
  selector: 'app-country-code-validation',
  templateUrl: './country-code-validation.component.html',
  styleUrls: ['./country-code-validation.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryCodeValidationComponent),
      multi: true,
    },
  ],
})
export class CountryCodeValidationComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates];
  @Input() telephoneFormControl: AbstractControl | any;
  @Input() form: FormGroup;
  @Input() controlName: string;

  private onChange: (value: string) => void;
  private onTouched: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2, private formGroupDirective: FormGroupDirective) {
  }

  ngAfterViewInit() {
    try {
      const element = this.el.nativeElement.querySelector('ngx-intl-tel-input');
      if (element && this.getControlName(this.telephoneFormControl)) {
        this.renderer.setAttribute(element, 'formControlName', this.getControlName(this.telephoneFormControl));
      }
    } catch (e) {
      console.error(e);
    }
  }

  ngOnInit(): void {

  }

  private getControlName(control: FormControl): string | null {
    const formGroup = this.formGroupDirective.form;
    return Object.keys(formGroup.controls).find(name => formGroup.get(name) === control) || null;
  }

  onCountryChange(event) {
    try {
      this.telephoneFormControl.reset();
    } catch (e) {

    }
  }

  /**
   * this method is use to Updates the form control value without emitting
   * an event to avoid triggering value change handlers multiple times.
   * @param value of input
   */
  writeValue(value: string): void {
    if (this.telephoneFormControl && this.telephoneFormControl.value !== value) {
      this.telephoneFormControl.setValue(value, { emitEvent: false });
    }
  }

  /**
   Registers the callback function to call when the value changes.
   **/
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  /**
   Registers the callback function to call when the form control is touched.
   **/
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
